import React, { FC, useEffect, useState } from 'react';
import { Button, Drawer, Form, Input, Tooltip } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { rules } from 'common/helpers';
import { EFormFieldMessage } from 'common/const';
import { Plus } from 'common/svg';
import { ICreateInvitationPayload } from 'entities/Invitation/Invitation.models';

interface IComponentProps {
  error: string | null;
  loading: boolean;
  onSendInvite: (values: ICreateInvitationPayload) => void;
}

export const SettingsAddUserButton: FC<IComponentProps> = ({ error, loading, onSendInvite }) => {
  const [openInviteForm, setOpenInviteForm] = useState<boolean>(false);
  const [form] = useForm();

  const onClose = () => {
    if (loading) {
      return;
    }

    setOpenInviteForm(false);
    form.resetFields();
  };

  const onSubmit = (values: ICreateInvitationPayload) => {
    onSendInvite({ ...values, onSuccess: onClose });
  };

  useEffect(() => {
    if (error) {
      form.setFields([{ name: 'email', errors: [error] }]);
    }
  }, [error]);

  return (
    <>
      <Tooltip title="Новый пользователь" placement="bottom">
        <Button
          className="button-circle primary"
          icon={<Plus className="icon-plus-white" />}
          onClick={() => setOpenInviteForm(true)}
        />
      </Tooltip>

      <Drawer
        rootClassName="redesign drawer account-user-list-settings-add-user-button__card"
        open={openInviteForm}
        width={720}
        onClose={onClose}
        destroyOnClose
        footer={
          <Button className="button-lg primary" onClick={form.submit} loading={loading}>
            Отправить приглашение
          </Button>
        }
      >
        <div className="drawer__body">
          <div className="drawer__title mb-14">Пригласить пользователя</div>

          <Form form={form} layout="vertical" requiredMark={false} onFinish={onSubmit}>
            <Form.Item
              className="mb-9"
              label="Электронная почта*"
              name="email"
              rules={[rules.required(), rules.type('email', EFormFieldMessage.InvalidEmailFormat)]}
            >
              <Input placeholder="Введите адрес электронной почты" />
            </Form.Item>

            <Form.Item className="mb-9" label="Фамилия*" name="lastName" rules={[rules.required()]}>
              <Input placeholder="Введите фамилию" />
            </Form.Item>

            <Form.Item className="mb-9" label="Имя*" name="firstName" rules={[rules.required()]}>
              <Input placeholder="Введите имя" />
            </Form.Item>

            <Form.Item className="mb-9" label="Отчество" name="patronymic">
              <Input placeholder="Введите отчество" />
            </Form.Item>
          </Form>
        </div>
      </Drawer>
    </>
  );
};
